/* ----------------------------------------------------------------------------
 * BEX "Patient Data Collection" visit form — Visit 2+ (Follow-up) Chapters
 *
 * Imports baseline chapters from bex.js and replaces Medication and Morbidities
 * with their Visit 2+ variants (which include medicationStopped and stoppedDate).
 * ------------------------------------------------------------------------- */
import {
  yesNo,
  anthropometrics,
  eatingDrinking,
  lungFunction,
  breathAnalysis,
} from './bex'

// Let's import default from bex to get smoking/questionnaire schemas
import bexVisit1 from './bex'

const smokingSchema = bexVisit1.chapters.find(c => c.key === 'smokingHistory')
  .schema
const questionnaireSchema = bexVisit1.chapters.find(
  c => c.key === 'questionnaire'
).schema

// BEX Medication V2 (with Stopped status and Stopped date)
export const medicationV2 = [
  {
    type: 'group',
    name: 'medication',
    repeatable: true,
    'add-label': '+ Add medication',
    children: [
      {
        type: 'drug',
        name: 'drugName',
        label: 'Drug (Trade Name)',
        placeholder: 'Drug (Trade Name)',
      },
      {
        type: 'text',
        name: 'activeSubstance',
        label: 'Active Substance',
        placeholder: 'Active Substance',
      },
      {
        type: 'number',
        name: 'dosagePerIntake',
        label: 'Dosage per Intake (mg)',
        placeholder: 'Dosage',
        min: '0',
        step: 'any',
      },
      {
        type: 'number',
        name: 'intakeMorning',
        label: 'Morning',
        help: 'Morning',
        min: '0',
        value: '0',
      },
      {
        type: 'number',
        name: 'intakeMidday',
        label: 'Midday',
        help: 'Midday',
        min: '0',
        value: '0',
      },
      {
        type: 'number',
        name: 'intakeEvening',
        label: 'Evening',
        help: 'Evening',
        min: '0',
        value: '0',
      },
      {
        type: 'number',
        name: 'intakeNight',
        label: 'Night',
        help: 'Night',
        min: '0',
        value: '0',
      },
      { type: 'datetime-local', name: 'lastIntake', label: 'Last intake' },
      { type: 'date', name: 'startedDate', label: 'Medication started' },
      {
        type: 'select',
        name: 'medicationStopped',
        label: 'Medication Stopped',
        options: yesNo,
      },
      {
        type: 'date',
        name: 'stoppedDate',
        label: 'Medication Stop Date',
      },
    ],
  },
]

// BEX Morbidities V2 (with Stopped date for morbidities, and changeInMorbidities select)
export const morbiditiesV2 = [
  {
    type: 'group',
    name: 'morbidities',
    repeatable: true,
    'add-label': '+ Add morbidity',
    children: [
      {
        type: 'icd',
        name: 'morbidity',
        label: 'Morbidity',
        placeholder: 'Type in ICD code',
      },
      {
        type: 'date',
        name: 'stoppedDate',
        label: 'Morbidity Stopped Date',
      },
    ],
  },
  {
    type: 'select',
    name: 'changeInMorbidities',
    label: 'Change in Morbidities',
    options: yesNo,
  },
  {
    type: 'group',
    name: 'comorbidities',
    repeatable: true,
    'add-label': '+ Add comorbidity',
    children: [
      {
        type: 'icd',
        name: 'comorbidity',
        label: 'Comorbidity',
        placeholder: 'Type in ICD code',
      },
    ],
  },
  { type: 'textarea', name: 'comments', label: 'Comments' },
]

const finish = [{ component: 'h4', children: 'Visit Completion' }]

export default {
  chapters: [
    {
      key: 'anthropometrics',
      name: 'Anthropometrics',
      schema: anthropometrics,
    },
    {
      key: 'eatingDrinking',
      name: 'Eating & drinking habits',
      schema: eatingDrinking,
    },
    { key: 'smokingHistory', name: 'Smoking history', schema: smokingSchema },
    { key: 'medication', name: 'Medication', schema: medicationV2 },
    { key: 'morbidities', name: 'Morbidities', schema: morbiditiesV2 },
    {
      key: 'questionnaire',
      name: 'Questionnaire',
      schema: questionnaireSchema,
    },
    { key: 'lungFunction', name: 'Lung Function', schema: lungFunction },
    { key: 'breathAnalysis', name: 'Breath analysis', schema: breathAnalysis },
    { key: 'finish', name: 'Visit completion', schema: finish },
  ],
}
